import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import Text from '../Text';
import { useState } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { api } from '../../maps/data.js';
import Divider from '@mui/material/Divider';
import { rndPiNumber } from '../../utils';
import Grid from '@mui/material/Grid';
import FieldShelf from '../field/FieldShelf';
import Btn from '../Btn';
import InstallerAddSensorToFieldDialog from './InstallerAddSensorToFieldDialog';
import InstallerAddCameraToFieldDialog from './InstallerAddCameraToFieldDialog';
import CameraShelfMarkerEditor from '../camera/CameraShelfMarkerEditor';
import CameraLive from "../camera/CameraLive";
import styled from "styled-components";
import IconBtn from '../IconBtn';
import { CAMERA_TYPE_ENUM } from "../../maps/data_types";
import PoseBorderForCamera from "../camera/PoseBorderForCamera";
import RoiTopCameraDialog from "./roiTopCamera/RoiTopCameraDialog";

const CameraItemStyled = styled.div`
  padding: 0 0 10px 0;
  position: relative;
`;

const VideoTypeLabelStyled = styled.div`
  font-size: 22px;
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 2;
  background: rgba(255, 255, 255, 0.8);
`;

const CameraListWrapper = styled.div`
    height: calc(-260px + 100vh);
    overflow: auto;
`;

export default function FieldDialog(props) {
    const _piNumber = props.piNumber || rndPiNumber();

    const { selectedSiteType, open, onClose, newField, field = {}, edgeId, siteId, edge, handleGetFields } = props;

    const [piNumber, s_piNumber] = useState(field.piNumber || _piNumber);
    const [name, s_name] = useState(field.name || `Field #${_piNumber}`);
    const [width, s_width] = useState(field.width || 99);
    const [height, s_height] = useState(field.height || 62);
    const [shelves, s_shelves] = useState(field?.shelves?.sort((a, b) => a.order - b.order) || []);
    const [cameras, s_cameras] = useState(field.cameras || []);
    const [open_sensors_dialog, s_open_sensors_dialog] = useState(false);
    const [open_cameras_dialog, s_open_cameras_dialog] = useState(false);
    const [open_top_camera_roi, s_open_top_camera_roi] = useState(false);
    const [camera_type, s_camera_type] = useState('');
    const [drawBoundingBox_shelf_idx, s_drawBoundingBox_shelf_idx] = useState(false);
    const [will_add_dot_idx, s_will_add_dot_idx] = useState(-1);
    const [cameraInUseId, s_cameraInUseId] = useState("");

    const save = async () => {
        await api({
            type: newField ? 'addField' : 'editField',
            data: {
                name, piNumber, width, height,
                edgeId,
                siteId,
                shelves,
                cameras,
                _id: field._id,
            }
        });
        onClose();
    }

    const editField = async (data, isClose, isGetFields) => {
        await api({
            type: 'editField',
            data: data
        });
        if (isClose) {
            onClose();
        }
        if (isGetFields) {
            handleGetFields();
        }
    }

    const addSensor = sensor => {
        const lastOrder = shelves[shelves?.length - 1]?.order;
        const newShelf = {
            sensorId: sensor._id,
            sensor,
            order: lastOrder + 1 || 1
        };
        s_shelves(shelves.concat([newShelf]));
    };

    const setCameras = (camera) => {
        const exists = cameras.find(cam => cam._id === camera._id);
        if (exists) {
            s_cameras(cameras.filter(cam => cam._id !== camera._id));
        } else {
            const camerasCopy = [...cameras];
            camera.cameraType = camera_type;
            camerasCopy.push(camera);
            s_cameras(camerasCopy);
        }
    };

    const setCameraBorder = (val) => {
        s_cameras(cameras.map(cam => {
            if (cam.cameraType === 'TOP') {
                cam.cameraBorder = val;
            }
            return cam;
        }));
    };

    const _onPlanogramChange = (planogram, shelfIdx) => {
        s_shelves(shelves.map((shelf, idx) => {
            if (shelfIdx === idx) {
                shelf.planogram = planogram
            }
            return shelf;
        }));
    }

    const deleteShelf = idx => {
        let _shelves = shelves.concat();
        _shelves.splice(idx, 1);
        s_shelves(_shelves);
    }

    const drawBoundingBox = (shelvId, shelfIndex, camId) => {
        if (camId) {
            s_cameraInUseId(camId);
            s_drawBoundingBox_shelf_idx(shelfIndex);
            s_will_add_dot_idx(0);
            s_shelves(shelves.map((shelf, idx) => {
                if (idx === shelfIndex) {
                    let boundingBoxes = shelf.boundingBoxes;
                    if (boundingBoxes?.length) {
                        boundingBoxes = boundingBoxes.filter(ee => ee.cameraId !== camId);
                        shelf.boundingBoxes = boundingBoxes;
                    }
                }
                return shelf;
            }));
        }
    }

    // const removeAllBoundingBox = () => {
    //     s_shelves(shelves.map(shelf => ({
    //         ...shelf,
    //         boundingBoxes: []
    //     })));
    // }

    const removeBoundingBox = (cameraId) => {
        console.log(shelves);
    
        s_shelves(
          shelves.map((shelf) => ({
            ...shelf,
            boundingBoxes: shelf.boundingBoxes.filter(
              (boundingBox) => boundingBox.cameraId !== cameraId
            ),
          }))
        );
      
      };


    const addDot = (dot, cameraId) => {
        s_will_add_dot_idx(will_add_dot_idx + 1);

        s_shelves(shelves.map((shelf, idx) => {
            if (idx === drawBoundingBox_shelf_idx) {
                let boundingBoxes = shelf.boundingBoxes;
                if (!boundingBoxes?.length) {
                    boundingBoxes = [{
                        cameraId: cameraId,
                        box: []
                    }];
                }
                boundingBoxes.forEach(boundingBox => {
                    if (boundingBox.cameraId === cameraId) {
                        if (boundingBox.box?.length === 4) {
                            // boundingBox.box = [];
                            boundingBox.box.concat([{ x_percent: dot.x_percent, y_percent: dot.y_percent }]);
                        } else {
                            boundingBox.box.concat([{ x_percent: dot.x_percent, y_percent: dot.y_percent }]);
                        }
                    }
                });
                return shelf;
            }
            return shelf;
        }));

        if (will_add_dot_idx === 3) {
            s_drawBoundingBox_shelf_idx(false);
        }
    }

    const onMoveDot = (dot, cameraId) => {
        if (!cameraInUseId || cameraInUseId !== cameraId) return;
        s_shelves(shelves.map((shelf, idx) => {
            if (idx === drawBoundingBox_shelf_idx) {
                if (!shelf.boundingBoxes?.length) {
                    shelf.boundingBoxes = [{
                        cameraId: cameraId,
                        box: [{ x_percent: dot.x_percent, y_percent: dot.y_percent }]
                    }];
                } else {
                    const boundingBox = shelf.boundingBoxes?.find(box => box.cameraId === cameraId);

                    if (!boundingBox) {
                        shelf.boundingBoxes.push({
                            cameraId: cameraId,
                            box: [{ x_percent: dot.x_percent, y_percent: dot.y_percent }]
                        });
                    } else {
                        boundingBox.box[will_add_dot_idx] = { x_percent: dot.x_percent, y_percent: dot.y_percent };
                    }
                }
            }
            return shelf;
        }));
    }

    const changeOrder = (shelfId, isUp) => {
        const shelvesData = [...shelves];
        shelvesData.forEach((shv, idx) => {
            if (shv._id === shelfId) {
                if (isUp) {
                    const prevShelf = shelvesData[idx - 1];
                    if (prevShelf) {
                        prevShelf.order = prevShelf.order + 1;
                    }
                    shv.order = shv.order - 1;
                } else {
                    const nextShelf = shelvesData[idx + 1];
                    if (nextShelf) {
                        nextShelf.order = nextShelf.order - 1;
                    }
                    shv.order = shv.order + 1;
                }
            }
        });
        shelvesData.sort((a, b) => a.order - b.order);
        s_shelves(shelvesData);
    };

    const topCamera = cameras?.find(cam => cam.cameraType === CAMERA_TYPE_ENUM.TOP);
    const camerasWithoutTop = cameras.filter(cam => cam.cameraType !== CAMERA_TYPE_ENUM.TOP);

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            fullScreen={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <ValidatorForm
                onSubmit={save}
                onError={errors => console.log(errors)}>

                <DialogTitle id="alert-dialog-title">
                    {newField ? <Tx>field.add.title</Tx> : <Tx>field.edit.title</Tx>}
                </DialogTitle>
                <DialogContent style={{ paddingTop: 5, height: 'calc(100vh - 140px)', overflowY: 'auto' }}>

                    <div style={{ width: 200, display: 'inline-block' }}>
                        <Text
                            label="g.name"
                            value={name}
                            onChange={s_name}
                            validators={['required']}
                            errorMessages={['this field is required']} />
                    </div>
                    <div style={{ width: 200, display: 'inline-block', marginLeft: 10 }}>
                        <Text
                            disabled={true}
                            label="g.piNumber"
                            value={piNumber}
                            onChange={s_piNumber}
                            validators={['required']}
                            errorMessages={['this field is required']} />
                    </div>
                    <div style={{ width: 200, display: 'inline-block', marginLeft: 10 }}>
                        <Text
                            label="g.width"
                            value={width}
                            onChange={s_width} />
                    </div>
                    <div style={{ width: 200, display: 'inline-block', marginLeft: 10 }}>
                        <Text
                            label="g.depth"
                            value={height}
                            onChange={s_height} />
                    </div>

                    <Divider style={{ marginBottom: 10 }} />

                    <Grid container spacing={2} style={{ marginTop: 10 }}>
                        <Grid item xs={4}>
                            {
                                shelves.map((shelf, idx) => {
                                    return (
                                        <FieldShelf
                                            drawBoundingBox={drawBoundingBox}
                                            hasCamera={!!camerasWithoutTop?.length}
                                            onDeleteShelf={() => deleteShelf(idx)}
                                            key={idx + shelf._id}
                                            cameras={camerasWithoutTop}
                                            nextOrder={shelves?.[idx + 1]?.order}
                                            shelfIndex={idx}
                                            width={width}
                                            {...shelf}
                                            onPlanogramChange={planogram => _onPlanogramChange(planogram, idx)}
                                            changeOrder={changeOrder}
                                        />
                                    );
                                })
                            }

                            <Btn startIcon="sensor" style={{ marginBottom: 15 }} onClick={() => { s_open_sensors_dialog(true) }}><Tx>g.add</Tx></Btn>

                            {topCamera && (
                                <>
                                    <CameraItemStyled>
                                        <CameraLive
                                        camera={topCamera}

                                            camera_info={topCamera.camera_info}
                                            profile_list={topCamera.profile_list}
                                            rtspUrl={topCamera.streamFullRtspUrl}
                                            rotate={topCamera.rotate}
                                            resolution={`480x270`}
                                        />

                                        {[{ left: 5, value: "startY" }, { left: 45, value: 'curve' }, {
                                            left: 90,
                                            value: 'endY'
                                        }].map((item, idx) => {
                                            return (
                                                <div
                                                    key={idx + item.value}
                                                    style={{
                                                        zIndex: 2,
                                                        position: 'absolute',
                                                        top: '45%',
                                                        left: `${item.left}%`
                                                    }}>
                                                    <div><IconBtn onClick={() => {
                                                        if (typeof topCamera.cameraBorder !== 'object') {
                                                            topCamera.cameraBorder = {
                                                                startY: 70,
                                                                endY: 70,
                                                                curve: 20
                                                            };
                                                        }
                                                        const newCameraItemBorder = { ...topCamera.cameraBorder };
                                                        newCameraItemBorder[item.value] = Math.max(newCameraItemBorder[item.value] - 5, 0);
                                                        setCameraBorder(newCameraItemBorder);
                                                    }}>arrowUp</IconBtn></div>

                                                    <div style={{ marginTop: 5 }}><IconBtn onClick={() => {
                                                        if (typeof topCamera.cameraBorder !== 'object') {
                                                            topCamera.cameraBorder = {
                                                                startY: 70,
                                                                endY: 70,
                                                                curve: 20
                                                            };
                                                        }
                                                        const newCameraItemBorder = { ...topCamera.cameraBorder };
                                                        newCameraItemBorder[item.value] = Math.min(newCameraItemBorder[item.value] + 5, 100);
                                                        setCameraBorder(newCameraItemBorder);
                                                    }}>arrowDown</IconBtn></div>
                                                </div>
                                            );
                                        })}
                                        <PoseBorderForCamera
                                            border={topCamera.cameraBorder}
                                        />
                                    </CameraItemStyled>
                                    <Btn
                                        startIcon="camera"
                                        onClick={() => setCameras(topCamera)}
                                    >
                                        <Tx>g.remove</Tx>
                                    </Btn>
                                    {selectedSiteType !== 'Inventory' && (
                                        <Btn
                                            style={{ marginLeft: 10 }}
                                            startIcon="gpsFixedIcon"
                                            onClick={() => {
                                                s_open_top_camera_roi(true);
                                            }}
                                        >
                                            <Tx>ROI</Tx>
                                        </Btn>
                                    )}
                                </>
                            )

                            }
                            {!topCamera && (

                                <div>
                                    <Btn style={{}} startIcon="camera" onClick={() => {
                                        s_open_cameras_dialog(true);
                                        s_camera_type(CAMERA_TYPE_ENUM.TOP);
                                    }}>
                                        <Tx>camera.addTopCamera</Tx>
                                    </Btn>
                                </div>

                            )
                            }

                        </Grid>

                        <Grid item xs={8}>
                            <CameraListWrapper>
                                {camerasWithoutTop.map((cam, idx) => {
                                    return (
                                        <CameraItemStyled key={cam._id + idx}>
                                            <VideoTypeLabelStyled>{cam.name}</VideoTypeLabelStyled>
                                            <CameraShelfMarkerEditor
                                                shelves={shelves}
                                                drawBoundingBox={drawBoundingBox_shelf_idx !== false}
                                                onAddDot={(dot => {
                                                    addDot(dot, cam._id);
                                                })}
                                                camera={cam}
                                                onMoveDot={(dot) => {
                                                    onMoveDot(dot, cam._id);
                                                }}
                                            />
                                            <Btn style={{marginTop: 5}} startIcon="camera" onClick={() => {
                                                setCameras(cam);
                                                // removeAllBoundingBox();
                                                removeBoundingBox(cam.cameraId);
                                            }}><Tx>g.remove</Tx></Btn>
                                        </CameraItemStyled>
                                    );
                                })}

                                <CameraItemStyled>
                                    <Btn
                                        startIcon="camera" onClick={() => {
                                        s_open_cameras_dialog(true);
                                        s_camera_type(CAMERA_TYPE_ENUM.FRONT);
                                    }}><Tx>camera.add.title</Tx></Btn>
                                </CameraItemStyled>
                            </CameraListWrapper>
                        </Grid>

                    </Grid>

                    {
                        open_sensors_dialog && <InstallerAddSensorToFieldDialog
                            edgeId={edgeId}
                            filterOutSensorIds={shelves.map(s => s.sensorId)}
                            addSensorTypes={["shelves", "shelves_weight"]}
                            open={open_sensors_dialog}
                            onClose={() => s_open_sensors_dialog(false)}
                            onSelect={sensor => { s_open_sensors_dialog(false); addSensor(sensor) }}
                        />
                    }

                    {
                        open_cameras_dialog && <InstallerAddCameraToFieldDialog
                            edgeId={edgeId}
                            onClose={() => {
                                s_open_cameras_dialog(false);
                                s_camera_type("");
                            }}
                            onSelect={camera => {
                                s_open_cameras_dialog(false);
                                setCameras(camera);
                            }}
                        />
                    }

                    {open_top_camera_roi && (
                        <RoiTopCameraDialog
                            edge={edge}
                            camera={topCamera}
                            saveBoxes={(roiBoxFloor, roiBoxPose) => {
                                cameras.forEach(cam => {
                                    if (cam.cameraType === 'TOP') {
                                        cam.roiBoxFloor = roiBoxFloor;
                                        cam.roiBoxPose = roiBoxPose;
                                    }
                                });
                                editField(
                                    {
                                        name,
                                        piNumber,
                                        width,
                                        height,
                                        edgeId,
                                        siteId,
                                        shelves,
                                        cameras,
                                        _id: field._id,
                                    }, false, true);
                            }}
                            onClose={() => {
                                s_open_top_camera_roi(false);
                            }}
                        />
                    )}

                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                    <Button autoFocus type='submit'>
                        <Tx>g.save</Tx>
                    </Button>
                </DialogActions>
            </ValidatorForm>
        </Dialog >)
}